export default "__VITE_ASSET__DERAPZcq__"